import React, { useEffect } from 'react';
import { get } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { GLOBAL_LABELS, SIZES } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { successOverlay as SuccessOverlay } from 'ui/views/widgets/successOverlay';
 *
 * // render
 * <SuccessOverlay propName='propValue'/>
 */
export const successOverlay = ( props ) => {

    const autoClose = get( props, 'config.autoClose', false );

    useEffect( () => {
    
        if( autoClose ) {

            setTimeout( () => {
                props.closeOverlay();
            }, 1200 );
        }

    }, [] );

    const bodyClassNames = classnames( 'ui-success-overlay__body', {
        'ui-success-overlay__body--large': SIZES.LARGE === get( props, 'config.overlaySize' )
    } );

    const messageClassnames = classnames( 'ui-success-overlay__body__message', {
        'ui-success-overlay__body__message--large': SIZES.LARGE === get( props, 'config.messageSize' )
    } );

    return (
        <div className='ui-success-overlay'>

            {/* body */}
            <div className={ bodyClassNames }>

                {/* icon */}
                <div className='ui-success-overlay__body__icon'>
                    <Icon name='hollowSuccessCheck' width='14' height='14' fill='#ffffff' />
                </div>

                {/* main message */}
                <div className={ messageClassnames }>
                    { props.message }
                </div>

                {/* sub message */}
                {
                    get( props, 'config.subMessage' ) ? (
                        <div className='ui-success-overlay__body__sub-message' dangerouslySetInnerHTML={ { __html: get( props, 'config.subMessage' ) } } />
                    ) : null
                }

                {/* close button */}
                {
                    !autoClose ? (
                        <Button
                            title={ GLOBAL_LABELS.DISPLAY_TEXT_CLOSE }
                            size={ SIZES.LARGE }
                            className='ui-success-overlay__body__close-button'
                            onClick={ () => {
                                if ( get( props, 'config.onCloseCallback', null ) ) {
                                    props.config.onCloseCallback();
                                }

                                props.closeOverlay();
                            } }
                        />
                    ) : null
                }
            </div>
        </div>
    );
};

// set display name
successOverlay.displayName = 'successOverlay';

// set default props
successOverlay.defaultProps = {};

// prop types
successOverlay.propTypes = {};
